export default __webpack_public_path__ + "static/media/yd-s4.912817de.png";